import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import {
  APP_REGISTRY_API_PATHS,
  APP_REGISTRY_LEVEL,
  APP_REGISTRY_VIEW_MODE,
  APP_REGISTRY_QUERY_KEY,
  getAppRegistryBaseUrl,
} from '@/constants/appRegistry';
import { useApiQuery } from './useApiQuery';

// GET the merged app-registry list for a user (includes user-level disabled apps, view=admin).
const useAppRegistryApps = ({ useruuid }) => {
  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);

  return useApiQuery(
    [APP_REGISTRY_QUERY_KEY, useruuid],
    () =>
      new Promise((resolve, reject) => {
        userApi.apiClient.callApi(
          APP_REGISTRY_API_PATHS.VIEW,
          'GET',
          {},
          {
            level: APP_REGISTRY_LEVEL.USER,
            useruuid,
            view: APP_REGISTRY_VIEW_MODE.ADMIN,
            // Cache-bust: enabled state mutates via PUT overrides, so a conditional GET
            // (304) can hand back the pre-update body instead of the fresh one.
            _: Date.now(),
          },
          {},
          {},
          null,
          [],
          ['application/json'],
          ['application/json'],
          Object,
          getAppRegistryBaseUrl(),
          apiCallback({
            translator: trans,
            successCallback: (data) => resolve(data?.apps || []),
            errorCallback: () => reject([]),
          })
        );
      }),
    { enabled: !!useruuid }
  );
};

export default useAppRegistryApps;
